import './shop-messages-route.component.js';
import './shop-messages-route.controller.js';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('inkfinder.shop.message-templates', {
    url: '/message-templates',
    views: {
      shop: {
        component: 'inkShopMessagesRoute'
      }
    },
    resolve: {
      $title: function() {
        return 'Shop messages';
      },
      messageTemplatesOwner: function(Session, Shop) {
        const shopId = Session.activeState.association.shop.id;
        return Shop.get(shopId).then(function(response) {
          return response;
        });
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/shop/messages/index.js